// This file contains compile-time defined variables.

export const TITLE_I386 = '#{spec/asm/mac/title-i386}' as unknown as {
	[p: string]: number[];
};

export const TITLE_X8664 = '#{spec/asm/mac/title-x86_64}' as unknown as {
	[p: string]: number[];
};

export const TITLE_ARM64 = '#{spec/asm/mac/title-arm64}' as unknown as {
	[p: string]: number[];
};
